<div
    class="collapser"
    [attr.aria-expanded]="visible"
    [attr.aria-controls]="collapseContentId"
    [ngClass]="{ collapsed: visible }"
    (click)="toggle()"
>
    <div
        [id]="labeledById"
        [class.sr-only]="!headerIsString"
        role="heading"
        [attr.aria-level]="headerLevel"
    >
        {{ headerText }}
    </div>
    @if (!headerIsString) {
        <div>
            <ng-container *ngTemplateOutlet="header"></ng-container>
        </div>
    }
</div>
@if (visible) {
    <div
        role="region"
        [attr.aria-labelledby]="labeledById"
        id="collapseContentId"
        class="divider-content"
    >
        <ng-content></ng-content>
    </div>
}
